export default function Section2() {
  return (
    <div className="Section2">
      <div className="md:w-[80%] my-[24px] mx-5 md:my-0 md:mx-auto text-center">
          <h1 className="text-[24px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#151515] mt-[40px]">
            Your Trusted Influencer Marketing Agency in Dubai
          </h1>

          <p className="pt-[1%] leading-[20px] text-[16px] font-open text-[#535353]">
            Mean3 is a leading Influencer Marketing Agency in Dubai, committed to helping brands
connect with their target audience through authentic and powerful campaigns. Our influencer
marketing services are designed to amplify your brand's message and foster long-term
relationships with your customers. Whether you're looking to hire an influencer for a product
launch or boost brand awareness, our team has the expertise to make it happen.
          </p>
        </div>
      <div className="section2-container my-[4%] md:my-0 md:justify-evenly md:items-center md:flex px-[20px] md:p-[50px_30px_0px_30px]">
        
        <div className="md:w-[36%]">
          <h2 className="text-[24px] md:text-[34px] leading-[32px] md:leading-[35px] font-bold text-[#DA2128] my-[0.67em]">
            Comprehensive Influencer Management Services
          </h2>

          <p className="leading-[20px] text-[#373737] pb-[1%] text-[16px] mb-5 font-open">
            Our team of experienced influencer managers provides full-scale influencer management
services. From choosing the right influencers to negotiating contracts and handling logistics, we
ensure that every detail is taken care of. We specialize in digital influencer marketing, focusing
on effective strategies to drive engagement and deliver measurable results. With our tailored
approach, you can trust us to elevate your brand's presence in the digital space.
          </p>
          <h2 className="text-[24px] md:text-[34px] leading-[32px] md:leading-[35px] font-bold text-[#DA2128] my-[0.67em]">
            Effective Influencer Outreach and Marketing Solutions
          </h2>

          <p className="leading-[20px] text-[#373737] pb-[1%] text-[16px] mb-5 font-open">
            At Mean3, we go beyond just influencer outreach services. We strategically identify influencers
that align with your brand’s values, ensuring that your marketing efforts resonate with the right
audience. As a leading fashion influencer marketing agency, we understand the importance of
authentic promotions. Our goal is to help you achieve impactful results through the power of
influencer marketing and grow your brand’s presence in the competitive market.
          </p>
        </div>

        <div className="w-full img-cont md:w-auto">
          <img className="w-full md:w-auto" src="/assets/brand-image-influencer-marketing.png"></img>
        </div>
      </div>
      
      <div className="line mx-auto my-[55px] md:my-[4%]  w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
